// extracted by mini-css-extract-plugin
module.exports = {"image-slide":"ImageSlider_image-slide__5GYR_","image-slide-content":"ImageSlider_image-slide-content__Su3xa","download-link":"ImageSlider_download-link__Fe4tX"};